<script>
    import {nextStep} from './stores/currentStep';

    export let image = '';
    export let title = '';
    export let subtitle = '';
    export let description = '';
    export let note = '';
</script>

<style>
    button {
        margin: 25px 0 0;
    }
    .content-box__note {
        padding-top: 40px;
    }
</style>

<main class="bg" style={`background-image: url(${image})`}>
    <div class="content-box">
        <h1 class="content-box__title">{title}</h1>
        <h2 class="content-box__subtitle">{subtitle}</h2>
        <p class="content-box__text">{description}</p>
        <button on:click={nextStep}>Начать тест</button>
        <p class="content-box__note">{@html note}</p>
    </div>
</main>